import { Controller } from "@hotwired/stimulus"

// Client-side CSV download. Reads the CSV payload embedded as JSON in
// data-csv-data ({ headers, rows }) and the filename from data-filename, then
// serializes to a downloaded file on click — no server round-trip.
// A UTF-8 BOM is prepended so Excel (JP) opens the multibyte text correctly.
export default class extends Controller {
  download() {
    let payload
    try {
      payload = JSON.parse(this.element.dataset.csvData || "{}")
    } catch (e) {
      console.error("[csv-download] bad data-csv-data:", e)
      return
    }
    const headers = payload.headers || []
    const rows = payload.rows || []
    const filename = this.element.dataset.filename || "export.csv"

    const lines = [headers, ...rows].map((row) => row.map((cell) => this.quote(cell)).join(","))
    const csv = "﻿" + lines.join("\r\n")

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  // RFC4180-style field quoting: wrap in double quotes and escape inner quotes.
  quote(value) {
    const s = value == null ? "" : String(value)
    return `"${s.replace(/"/g, '""')}"`
  }
}
